/**
 * D4F COLLECTION DESCRIPTION - TOGGLE FUNCTIONALITY
 * - Smooth expand/collapse animation
 * - Accessibility features (ARIA attributes)
 * - Scroll to content after expand
 * - Local storage to remember state (optional)
 */
(function () {
  const section = document.querySelector('.d4f-collection-description-section');
  if (!section) return;

  const toggleButton = section.querySelector('.seo-text-toggle');
  const seoText = section.querySelector('.seo-text');

  if (!toggleButton || !seoText) return;

  // Initialize
  initToggle();

  /**
   * TOGGLE FUNCTIONALITY
   */
  function initToggle() {
    // Check if state should be remembered (optional)
    const rememberState = false; // Set to true if you want to remember state
    let isOpen = false;

    if (rememberState) {
      const savedState = localStorage.getItem('d4f-seo-text-state');
      if (savedState === 'open') {
        openText(false); // Open without animation on load
        isOpen = true;
      }
    }

    // Click handler
    toggleButton.addEventListener('click', function () {
      isOpen = !isOpen;

      if (isOpen) {
        openText(true);
        if (rememberState) {
          localStorage.setItem('d4f-seo-text-state', 'open');
        }
      } else {
        closeText();
        if (rememberState) {
          localStorage.setItem('d4f-seo-text-state', 'closed');
        }
      }
    });

    // Keyboard accessibility
    toggleButton.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleButton.click();
      }
    });
  }

  /**
   * OPEN TEXT
   */
  function openText(withScroll = true) {
    seoText.classList.add('is-open');
    toggleButton.setAttribute('aria-expanded', 'true');
    seoText.setAttribute('aria-hidden', 'false');

    // Smooth scroll to content after animation
    if (withScroll) {
      setTimeout(() => {
        scrollToText();
      }, 400); // Wait for animation to start
    }
  }

  /**
   * CLOSE TEXT
   */
  function closeText() {
    seoText.classList.remove('is-open');
    toggleButton.setAttribute('aria-expanded', 'false');
    seoText.setAttribute('aria-hidden', 'true');

    // Scroll back to button
    setTimeout(() => {
      scrollToButton();
    }, 200);
  }

  /**
   * SCROLL TO TEXT
   */
  function scrollToText() {
    const offset = 100; // Offset from top
    const textPosition = seoText.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: textPosition,
      behavior: 'smooth',
    });
  }

  /**
   * SCROLL TO BUTTON
   */
  function scrollToButton() {
    const offset = 150; // Offset from top
    const buttonPosition = toggleButton.getBoundingClientRect().top + window.pageYOffset - offset;

    // Only scroll if button is not in view
    if (buttonPosition < window.pageYOffset) {
      window.scrollTo({
        top: buttonPosition,
        behavior: 'smooth',
      });
    }
  }

  /**
   * DYNAMIC HEIGHT CALCULATION
   * Ensures smooth animation even with dynamic content
   */
  function updateHeight() {
    if (seoText.classList.contains('is-open')) {
      const height = seoText.scrollHeight;
      seoText.style.maxHeight = height + 'px';
    }
  }

  // Update height on window resize
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateHeight, 250);
  });

  /**
   * LAZY LOAD IMAGES IN SEO TEXT
   */
  function initLazyImages() {
    const images = seoText.querySelectorAll('img');
    if (images.length === 0) return;

    const imageObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imageObserver.unobserve(img);
        }
      });
    });

    images.forEach((img) => {
      imageObserver.observe(img);
    });
  }

  initLazyImages();

  /**
   * ANALYTICS TRACKING (OPTIONAL)
   */
  function trackToggle(action) {
    // Example: Google Analytics tracking
    if (typeof gtag !== 'undefined') {
      gtag('event', 'seo_text_toggle', {
        event_category: 'engagement',
        event_label: action,
        value: 1,
      });
    }

    // Example: Custom tracking
    console.log('[D4F SEO Text] Toggled:', action);
  }

  // Add tracking to toggle button
  toggleButton.addEventListener('click', function () {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    trackToggle(isExpanded ? 'close' : 'open');
  });

  console.log('[D4F Collection Description] Initialized successfully');
})();